var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smart2_Time"},[_c('title1',{attrs:{"type":"1","title":"规划场站周边看板","subTitle":"Electric Port Overview","right":true},scopedSlots:_vm._u([{key:"uuid",fn:function(){return undefined},proxy:true}])}),_c('div',{ref:"pietwo",staticClass:"pieon2",attrs:{"id":"smart2_4"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }